export class ValidationError extends Error {
  public readonly url: string
  public readonly context?: Record<string, unknown>

  constructor(message: string, url: string, context?: Record<string, unknown>) {
    super(message)
    this.name = this.constructor.name
    this.url = url
    this.context = context
  }
}

export class RedirectDirectiveError extends ValidationError {}
